import { render, staticRenderFns } from "./financialArchivingSettings.vue?vue&type=template&id=24dca5de&scoped=true&"
import script from "./financialArchivingSettings.vue?vue&type=script&lang=js&"
export * from "./financialArchivingSettings.vue?vue&type=script&lang=js&"
import style0 from "./financialArchivingSettings.vue?vue&type=style&index=0&id=24dca5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dca5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24dca5de')) {
      api.createRecord('24dca5de', component.options)
    } else {
      api.reload('24dca5de', component.options)
    }
    module.hot.accept("./financialArchivingSettings.vue?vue&type=template&id=24dca5de&scoped=true&", function () {
      api.rerender('24dca5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/financialArchivingSettings.vue"
export default component.exports